import {connect} from 'react-redux';

import {getI18n, getLocalize} from '../../src/store/stateless/internationalizationSelectors';
import {makeMapStateToProps} from '../helpers/reselectHelpers';
import {InternationalizationProvider} from './internationalizationProvider';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  i18n: getI18n,
  localize: getLocalize,
}));

export const InternationalizationProviderContainer = connect(mapStateToProps)(InternationalizationProvider);
